module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.onoff) ? _c('div', {
    staticClass: "rooter",
    on: {
      "click": _vm.loginFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("立即登录")])], 1) : _vm._e(), _vm._v(" "), (!_vm.onoff) ? _c('div', {
    staticClass: "rooter",
    on: {
      "click": _vm.loginFn
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("立即注册")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "has-account"
  }, [_vm._v(_vm._s(!_vm.onoff ? '未有账号？' : '已有账号？'))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../img/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bf61b56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 109
// module chunks = 1